import React, { FC } from 'react';
import Loader from './Loader';

import Placeholder from './Placeholder';
import { Container, Header, Row, Caption } from './styles';
import { Props } from './types';

const Orders: FC<Props> = ({
  tabName,
  isSearching,
  isLoading,
  orders,
  ...props
}) => {
  if (isLoading) {
    return (
      <Container>
        <Header>
          <span />
          <Caption>Customer</Caption>
          <Caption>Restaurant</Caption>
          <Caption>Order №</Caption>
          <Caption>Date</Caption>
          <Caption>Time</Caption>
          <Caption>Status</Caption>
          <span />
        </Header>
        <Loader opacity={1} />
        <Loader opacity={0.75} />
        <Loader opacity={0.5} />
        <Loader opacity={0.25} />
        <Loader opacity={0.25} />
        <Loader opacity={0} />
      </Container>
    );
  }

  if (orders.length === 0) {
    return (
      <Placeholder
        message={
          isSearching
            ? `Sorry, we couldn’t find any order that fits with your search`
            : `You don’t have any ${tabName} orders`
        }
      />
    );
  }

  return (
    <Container {...props}>
      <Header>
        <span />
        <Caption>Customer</Caption>
        <Caption>Restaurant</Caption>
        <Caption>Order №</Caption>
        <Caption>Date</Caption>
        <Caption>Time</Caption>
        <Caption>Status</Caption>
        <span />
      </Header>
      {orders.map((order) => (
        <Row key={order.id} order={order} />
      ))}
    </Container>
  );
};

export default Orders;
